<!--
  Generated template for the NearbyMapPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-content fullscreen no-bounce="true" force-overscroll="false">
  <ion-header class="no-shadow">
    <ion-toolbar class="no-shadow">
      <ion-buttons slot="start" >
        <ion-back-button [defaultHref]="'/event/details/tabs'" (click)="closeNearby()"></ion-back-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button fill="clear" color="light" aria-label="{{ 'GLOBAL_MYSPORT' | translate }}" (click)="showLogin()">
          <span
            *ngIf="isLoged()"
            [style.background-image]="'url(' + profileImage() + ')'"
            class="user-image-m"
            style="border-radius: 50%; display: inline-block; width: 32px; height: 32px;">
          </span>
          <span
            *ngIf="!isLoged()"
            [style.background-image]="'url(/assets/imgs/default-image-32@1x.png)'"
            class="user-image-m"
            style="border-radius: 50%; display: inline-block; width: 32px; height: 32px;">
          </span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <google-maps *ngIf="isGoogleMap" [maxZoom]="22" (mapLoaded)="loaded($event)"></google-maps>
  <div id="mapnearby" style="height: 100%;z-index: 1;" *ngIf="!isGoogleMap">
  </div>
  
  <div class="nearby-main-slides" *ngIf="reloadTrigger">
  <swiper-container
    #dataSlider
    (swiper)="onSwiperInit($event)"
    [pagination]="{ clickable: true }"
    (slidechange)="ionSlideDidChange()"
    style="width: 100%; height: 100%;">
    <!-- <ion-slides #dataSlider pager="true" (ionSlideDidChange)="ionSlideDidChange(this,$event)"> -->
      <!-- <ion-slide *ngFor="let evt of nearbyEvents; index as i"> -->
      <swiper-slide *ngFor="let evt of nearbyEvents; index as i">
        <ion-content>
          <ion-fab vertical="top" horizontal="end" slot="fixed" *ngIf="!getMode(i)" class="peope-fab">
            <ion-fab-button (click)="showParticipantList()">
              <ion-icon name="people"></ion-icon>
              </ion-fab-button>
            </ion-fab>
        </ion-content>
        <ion-card  *ngIf="!detectorProvider.isSpooortsApp()" class="swiper-size">
          <ion-card-header class="ion-text-start">
            <ion-note text-small style="color:black">
              <ion-icon *ngIf="raceState === 0" name="alarm" color="danger" ></ion-icon>
              <span *ngIf="getMode(i)">
                <ion-icon name="radio-button-on" color="danger" *ngIf="raceState === 1"></ion-icon>
                {{ (raceState === 0 ? '' : '') | translate }}
                {{ texts.countDown }} &middot;
              </span>
              <!-- <strong>{{ evt.event.name }}</strong>
              <br>
              <strong>{{ evt.streckeconv }} - {{ evt.wertung }}</strong> -->
              {{ evt.streckeconv }} &middot; {{ evt?.name || evt.event.name }} &middot;
            </ion-note>
          </ion-card-header>
          <ion-card-content class="no-padding-bottom">
            <ion-item margin-vertical *ngIf="!getMode(i)">
              <ion-col>
                <h1  class="ion-text-center ion-text-bold">{{ texts.countDown }}</h1>
                <p class="ion-text-center">
                  {{ (raceState === 1 ? 'NEARBY_RACE' : raceState === 0 ? 'NEARBY_COUNTDOWN' : '') | translate }}</p>
              </ion-col>
            </ion-item>
            <div margin-vertical *ngIf="getMode(i)">
              <h6 class="ion-text-bold ion-text-center ion-padding-vertical" >{{ 'NEARBY_PARTICIPATE_TYPE_QUESTION' | translate }}</h6>
              <ion-row>
                <ion-col size="6" padding-top class="ion-text-center" color="primary" (click)="showParticipantSearchPage()">
                  <h1 class="ion-no-margin ion-text-primary">
                    <ion-icon name="eye"></ion-icon>
                  </h1>
                  <p class="ion-no-margin ion-text-primary">{{ 'NEARBY_SPECTATOR' | translate }}</p>
                </ion-col>
                <ion-col size="6" padding-top class="ion-text-center" color="primary" (click)="register()">
                  <h1 class="ion-no-margin ion-text-primary">
                    <ion-icon name="body"></ion-icon>
                  </h1>
                  <p class="ion-no-margin ion-text-primary">{{ 'NEARBY_COMPETITOR' | translate }}</p>
                </ion-col>
              </ion-row>
            </div>

            <div *ngIf="!getMode(i)">
              <!-- <ion-fab vertical="top" horizontal="end" slot="fixed">
                <ion-fab-button (click)="showParticipantList()">
                  <ion-icon name="people"></ion-icon>
                </ion-fab-button>
              </ion-fab> -->

              <!-- Hannover App -->
              <ion-fab vertical="top" horizontal="start" *ngIf="buttonPlayStop && !play">
                <ion-fab-button size="small" color="light" class="secondary-fab" (click)="onPlayToogle()">
                  <ion-icon name="play"></ion-icon>
                </ion-fab-button>
              </ion-fab>

              <ion-fab vertical="top" horizontal="start" *ngIf="buttonPlayStop && play">
                <ion-fab-button size="small" color="light" class="secondary-fab" (click)="onPlayToogle()">
                  <ion-icon name="stop-outline"></ion-icon>
                </ion-fab-button>
              </ion-fab>

              <ion-fab vertical="top" horizontal="end" *ngIf="buttonPlayStop">
                <ion-fab-button size="small" color="light" class="secondary-fab" (click)="onResultsRedirect()">
                  <ion-icon name="list"></ion-icon>
                </ion-fab-button>
              </ion-fab>

              <!-- -->

              <!-- Sponsor App  -->
              <ion-fab vertical="top" horizontal="start" *ngIf="buttonsNearby">
                <ion-fab-button size="small" color="light" class="secondary-fab" (click)="openModify()">
                  <ion-icon name="list"></ion-icon>
                </ion-fab-button>
              </ion-fab>

              <ion-fab vertical="top" horizontal="end" *ngIf="buttonsNearby">
                <ion-fab-button size="small" [color]="trackMyLocation ? 'primary' : 'light'" class="secondary-fab" (click)="changeTrackingStatus()">
                  <ion-icon name="locate"></ion-icon>
                </ion-fab-button>
              </ion-fab>

              <!-- -->

              <ion-row *ngIf="rowKmStatistics">
                <ion-col size="4">
                  <h2 class="ion-text-bold ion-text-center">{{ texts.firstDistance }}</h2>
                  <p class="ion-text-center ion-text-small">{{ 'NEARBY_KM_LEADER' | translate }}</p>
                </ion-col>
                <ion-col size="4">
                  <h2 class="ion-text-bold ion-text-center">{{ texts.middleDistance }}</h2>
                  <p class="ion-text-center ion-text-small">{{ 'NEARBY_KM_MIDFIELD' | translate }}</p>
                </ion-col>
                <ion-col size="4">
                  <h2 class="ion-text-bold ion-text-center">{{ texts.lastDistance }}</h2>
                  <p class="ion-text-center ion-text-small">{{ 'NEARBY_KM_LAST' | translate }}</p>
                </ion-col>
              </ion-row>
            </div>
          </ion-card-content>
        </ion-card>
      <!-- </ion-slide> -->
      </swiper-slide>
    <!-- </ion-slides> -->
  </swiper-container>
  </div>
</ion-content>

<div id="tutorialTrack1" class="tutorial-container {{'GLOBAL_LANG_SHORT' | translate}}" style="display: none;">
  <div class="tutorial-page tutorial-page-rounded tutorial-page-track-1">
    <div class="tutorial-overlay">
      <span class="tutorial-image"> </span>
    </div>
  </div>
</div>
<div id="tutorialTrack2" class="tutorial-container {{'GLOBAL_LANG_SHORT' | translate}}" style="display: none;">
  <div class="tutorial-page tutorial-page-rounded tutorial-page-track-2">
    <div class="tutorial-overlay">
      <span class="tutorial-image"> </span>
    </div>
  </div>
</div>
<div id="tutorialTrack3" class="tutorial-container {{'GLOBAL_LANG_SHORT' | translate}}" style="display: none;">
  <div class="tutorial-page tutorial-page-rounded tutorial-page-track-3">
    <div class="tutorial-overlay">
      <span class="tutorial-image"> </span>
    </div>
  </div>
</div>